document.addEventListener('DOMContentLoaded', function() {

// ============================================
  // HEADER - Mobile Menu Toggle
  // ============================================
  const openBtn = document.getElementById('vp-menu-open');
  const closeBtn = document.getElementById('vp-menu-close');
  const mobileMenu = document.getElementById('vp-mobile-menu');
  const hiddenBody = document.querySelector("body");


  if (openBtn && closeBtn && mobileMenu) {
    openBtn.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      closeBtn.classList.add('active');
      openBtn.classList.remove('active');
      document.body.classList.add('vp-menu-open');
      hiddenBody.classList.add('vp-body-hidden');
    });

    closeBtn.addEventListener('click', function() {
      mobileMenu.classList.remove('active');
      openBtn.classList.add('active');
      closeBtn.classList.remove('active');
      document.body.classList.remove('vp-menu-open');
      hiddenBody.classList.remove('vp-body-hidden');
    });
  }

  // ============================================
  // HEADER - Mobile Dropdown Navigation
  // ============================================
  const openMobBtns = document.querySelectorAll('.vp-mob-dropdown');

  openMobBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const nextEl = this.nextElementSibling;
      if (nextEl) {
        nextEl.classList.add('vp-mob-menu-active');
      }
    });
  });

  // ============================================
  // HEADER - Mobile Back Button
  // ============================================
  const closeMobBtns = document.querySelectorAll('.vp-mob-menu-left');

  closeMobBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const parentMenu = this.closest('.vp-dropdown');
      if (parentMenu) {
        parentMenu.classList.remove('vp-mob-menu-active');
      }
    });
  });

  // ============================================
  // HEADER - Tab Switching (Mattresses - 4 tabs)
  // ============================================
  const tabButtons = document.querySelectorAll('.vp-tab-btn');
  const tabContents = document.querySelectorAll('.vp-tab-content');

  tabButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tabButtons.forEach(function(b) {
        b.classList.remove('vp-active');
      });
      tabContents.forEach(function(c) {
        c.classList.remove('vp-active');
      });

      btn.classList.add('vp-active');
      const target = document.getElementById(btn.dataset.tab);
      if (target) target.classList.add('vp-active');
    });
  });

  // ============================================
  // HEADER - Tab Switching (Bedroom - 2 tabs)
  // ============================================
  const tabButtonsTwo = document.querySelectorAll('.vp-tab-btn-two');
  const tabContentsTwo = document.querySelectorAll('.vp-tab-content-two');

  tabButtonsTwo.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tabButtonsTwo.forEach(function(b) {
        b.classList.remove('vp-active');
      });
      tabContentsTwo.forEach(function(c) {
        c.classList.remove('vp-active');
      });

      btn.classList.add('vp-active');
      const target = document.getElementById(btn.dataset.tab);
      if (target) target.classList.add('vp-active');
    });
  });

  // ============================================
  // HEADER - Mobile Accordion (scoped to mobile menu)
  // ============================================
  const mobileAccordionTitles = document.querySelectorAll('#vp-mobile-menu .vp-accordion-title');

  mobileAccordionTitles.forEach(function(title) {
    title.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const item = this.parentElement; // .vp-accordion-item
      const isActive = item.classList.contains('active');
      
      // Close all siblings in same accordion container
      const accordionContainer = this.closest('.vp-accordion');
      if (accordionContainer) {
        accordionContainer.querySelectorAll('.vp-accordion-item').forEach(function(sibling) {
          sibling.classList.remove('active');
        });
      }
      
      // Toggle current (if it was closed, open it)
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

 // ============================================
// HEADER - Search Popup
// ============================================
const searchBtn = document.querySelector('.vp-search-btn');
const searchDropdown = document.querySelector('.vp-search-dropdown');
const searchCloseBtn = document.querySelector('.vp-search-close');
const searchInput = document.querySelector('.vp-search-input');
const searchTabs = document.querySelectorAll('.vp-results-tab');
const searchTabContents = document.querySelectorAll('.vp-results-tab-content');

if (searchBtn && searchDropdown) {
  // Open search
  searchBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    searchDropdown.classList.add('active');
    document.body.classList.add('vp-search-open');
   // Focus immediately for mobile keyboard to appear
  if (searchInput) {
    searchInput.focus();
    // Also set selection to end of any existing text
    searchInput.setSelectionRange(searchInput.value.length, searchInput.value.length);
  }
  });

  // Close search
  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', function() {
      searchDropdown.classList.remove('active');
      document.body.classList.remove('vp-search-open');
    });
  }

  // Close on ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchDropdown.classList.contains('active')) {
      searchDropdown.classList.remove('active');
      document.body.classList.remove('vp-search-open');
    }
  });

  // Tab switching
  searchTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      searchTabs.forEach(function(t) { t.classList.remove('active'); });
      searchTabContents.forEach(function(c) { c.classList.remove('active'); });
      tab.classList.add('active');
      const target = document.getElementById(tab.dataset.target);
      if (target) target.classList.add('active');
    });
  });
}

  // ============================================
  // Product Swiper
  // ============================================
  if (typeof Swiper !== 'undefined') {

    if (document.querySelector('.vp-mySwiper-product')) {
      new Swiper(".vp-mySwiper-product", {
        slidesPerView: 1.1,
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          500: { slidesPerView: 1.5 },
          768: { slidesPerView: 2.3 },
          998: { slidesPerView: 2.5 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        }
      });
    }

    if (document.querySelector('.vp-testimonial-swiper')) {
      new Swiper('.vp-testimonial-swiper', {
        loop: true,
        spaceBetween: 60,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        speed: 700,
        effect: 'slide',
      });
    }

    if (document.querySelector('.vp-popular-category')) {
      new Swiper('.vp-popular-category', {
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          500: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          990: { slidesPerView: 4, spaceBetween: 24 },
          1200: { slidesPerView: 6, spaceBetween: 24 }
        }
      });
    }

    if (document.querySelector('.vp-mySwiper-product-two')) {
      new Swiper(".vp-mySwiper-product-two", {
        slidesPerView: 1.1,
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button-next-two",
          prevEl: ".swiper-button-prev-two",
        },
        breakpoints: {
          500: { slidesPerView: 1.5 },
          768: { slidesPerView: 2.3 },
          998: { slidesPerView: 2.5 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        }
      });
    }

    if (document.querySelector('.vp-mySwiper-product-three')) {
      new Swiper(".vp-mySwiper-product-three", {
        slidesPerView: 1.1,
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button-next-three",
          prevEl: ".swiper-button-prev-three",
        },
        breakpoints: {
          500: { slidesPerView: 1.5 },
          768: { slidesPerView: 2.3 },
          998: { slidesPerView: 2.5 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        }
      });
    }

  } // End Swiper check

  // ============================================
  // Product Size Dropdown
  // ============================================
  const sizeDropdowns = document.querySelectorAll('.vp-product-size-dropdown');

  sizeDropdowns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      const nextEl = this.nextElementSibling;

      document.querySelectorAll('.vp-size-dropdown-active').forEach(function(drop) {
        if (drop !== nextEl) drop.classList.remove('vp-size-dropdown-active');
      });

      if (nextEl) {
        nextEl.classList.toggle('vp-size-dropdown-active');
        this.classList.toggle('vp-size-icon-active');
      }
    });
  });

  document.addEventListener('click', function() {
    document.querySelectorAll('.vp-size-dropdown-active').forEach(function(drop) {
      drop.classList.remove('vp-size-dropdown-active');
    });
  });

  // ============================================
  // FAQ Accordion
  // ============================================
  const faqItems = document.querySelectorAll(".vp-faq-item");

  faqItems.forEach(function(item) {
    const btn = item.querySelector(".vp-faq-question");
    if (btn) {
      btn.addEventListener("click", function() {
        faqItems.forEach(function(i) {
          if (i !== item) i.classList.remove("vp-active");
        });
        item.classList.toggle("vp-active");
      });
    }
  });

  // ============================================
  // Catalog Filters Dropdown
  // ============================================
  const filterDropdowns = document.querySelectorAll(".vp-filters-dropdown");

  filterDropdowns.forEach(function(dropdown) {
    const btn = dropdown.querySelector(".vp-filter-btn");
    const menu = dropdown.querySelector(".vp-filters-dropdown-menu");

    if (btn && menu) {
      btn.addEventListener("click", function(e) {
        e.stopPropagation();
        document.querySelectorAll(".vp-filters-dropdown.open").forEach(function(other) {
          if (other !== dropdown) other.classList.remove("open");
        });
        dropdown.classList.toggle("open");
      });

      menu.addEventListener("click", function(e) {
        e.stopPropagation();
      });
    }
  });

  document.addEventListener("click", function() {
    document.querySelectorAll(".vp-filters-dropdown.open").forEach(function(m) {
      m.classList.remove("open");
    });
  });

  // ============================================
  // Catalog Filters Accordion
  // ============================================
  const filterAccordions = document.querySelectorAll(".vp-accordion-filters .vp-accordion");

  filterAccordions.forEach(function(accordion) {
    accordion.addEventListener('click', function() {
      this.classList.toggle("vp-is-open");
      const content = this.nextElementSibling;
      if (content) {
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      }
    });
  });

  // ============================================
  // Price Range Slider
  // ============================================
  const rangeInput = document.querySelectorAll(".vp-range-input input");
  const priceInput = document.querySelectorAll(".vp-price-input input");
  const rangeProgress = document.querySelector(".vp-range-slider .vp-progress");
  const priceGap = 1000;

  if (rangeInput.length && priceInput.length && rangeProgress) {
    priceInput.forEach(function(input) {
      input.addEventListener("input", function(e) {
        let minPrice = parseInt(priceInput[0].value);
        let maxPrice = parseInt(priceInput[1].value);

        if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
          if (e.target.className === "input-min") {
            rangeInput[0].value = minPrice;
            rangeProgress.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
          } else {
            rangeInput[1].value = maxPrice;
            rangeProgress.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
          }
        }
      });
    });

    rangeInput.forEach(function(input) {
      input.addEventListener("input", function(e) {
        let minVal = parseInt(rangeInput[0].value);
        let maxVal = parseInt(rangeInput[1].value);

        if (maxVal - minVal < priceGap) {
          if (e.target.className === "range-min") {
            rangeInput[0].value = maxVal - priceGap;
          } else {
            rangeInput[1].value = minVal + priceGap;
          }
        } else {
          priceInput[0].value = minVal;
          priceInput[1].value = maxVal;
          rangeProgress.style.left = (minVal / rangeInput[0].max) * 100 + "%";
          rangeProgress.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
        }
      });
    });
  }

}); // End DOMContentLoaded


// PRODUCT CARD - Variant Selector & Add to Cart
document.addEventListener('DOMContentLoaded', function() {
  
  // Variant Dropdown Toggle
  document.querySelectorAll('.vp-product-card [data-dropdown-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const wrapper = this.closest('.vp-product-size-wrapper');
      
      // Close other dropdowns
      document.querySelectorAll('.vp-product-size-wrapper.active').forEach(function(other) {
        if (other !== wrapper) other.classList.remove('active');
      });
      
      wrapper.classList.toggle('active');
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.vp-product-size-wrapper')) {
      document.querySelectorAll('.vp-product-size-wrapper.active').forEach(function(wrapper) {
        wrapper.classList.remove('active');
      });
    }
  });

 // Variant Selection - using event delegation
document.addEventListener('change', function(e) {
  if (!e.target.matches('.vp-product-card .vp-filterDropdownItem input[type="radio"]')) return;
  
  const input = e.target;
  const card = input.closest('.vp-product-card');
  const wrapper = input.closest('.vp-product-size-wrapper');
  
  // Update selected variant display
  const selectedText = card.querySelector('.vp-selected-variant');
  if (selectedText && input.dataset.variantTitle) {
    selectedText.textContent = input.dataset.variantTitle;
  }

  // Update price
  const currentPrice = card.querySelector('.vp-current-price');
  if (currentPrice && input.dataset.variantPrice) {
    currentPrice.textContent = input.dataset.variantPrice;
  }

  // Get price values
  const priceRaw = parseInt(input.dataset.variantPriceRaw) || 0;
  const comparePriceRaw = parseInt(input.dataset.variantComparePriceRaw) || 0;
  
  // Update compare price and discount badge
  const comparePrice = card.querySelector('.vp-compare-price');
  const discountBadge = card.querySelector('.vp-discount-badge');
  const discountPercent = card.querySelector('.vp-discount-percent');
  
  if (comparePriceRaw > priceRaw) {
    // Has discount
    const discount = Math.round(((comparePriceRaw - priceRaw) / comparePriceRaw) * 100);
    
    // Show and update compare price
    if (comparePrice) {
      comparePrice.style.display = '';
      comparePrice.querySelector('del').textContent = input.dataset.variantComparePrice;
    }
    
    // Show and update discount badge
    if (discountBadge) {
      discountBadge.style.display = '';
      if (discountPercent) {
        discountPercent.textContent = discount + '% Off';
      }
    }
  } else {
    // No discount
    if (comparePrice) {
      comparePrice.style.display = 'none';
    }
    if (discountBadge) {
      discountBadge.style.display = 'none';
    }
  }

  // Update add to cart button
  const addToCartBtn = card.querySelector('.vp-add-to-cart');
  if (addToCartBtn && input.dataset.variantId) {
    addToCartBtn.dataset.variantId = input.dataset.variantId;
    
    if (input.dataset.variantAvailable === 'true') {
      addToCartBtn.disabled = false;
      addToCartBtn.innerHTML = '<span class="vp-svg-span"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.1103 1.85961C12.4421 1.65781 12.8683 1.74384 13.0976 2.04711L13.1406 2.11059L14.8379 4.8977H15.207C16.7185 4.89792 17.8398 6.29312 17.5205 7.76684L17.0185 10.0813C17.7841 10.9483 18.25 12.0869 18.25 13.3342C18.2495 16.0486 16.0494 18.2499 13.334 18.2502L13.081 18.2444C11.1711 18.1477 9.54957 16.9595 8.82419 15.2922H5.34274C4.22914 15.2922 3.26392 14.516 3.02927 13.425V13.4241L1.80368 7.76684V7.76586C1.48566 6.29231 2.60815 4.8977 4.11716 4.8977H4.46774L6.01169 2.13402L6.0527 2.06957C6.27066 1.75813 6.69318 1.65659 7.0322 1.84594C7.39371 2.04799 7.52325 2.50488 7.32126 2.86645L6.18649 4.8977H13.082L11.8593 2.88988L11.8232 2.8225C11.6594 2.47956 11.7787 2.06158 12.1103 1.85961ZM13.334 9.91723C11.4473 9.91723 9.91696 11.4476 9.91696 13.3342C9.91739 15.1616 11.3533 16.655 13.1582 16.7463L13.334 16.7502L13.5097 16.7463C15.3148 16.6546 16.7495 15.1614 16.75 13.3342C16.75 11.4477 15.221 9.91757 13.334 9.91723ZM13.334 11.1252C13.7479 11.1256 14.084 11.4612 14.084 11.8752V12.5842H14.792L14.8681 12.5881C15.2464 12.6265 15.542 12.9459 15.542 13.3342C15.5415 13.7223 15.2462 14.042 14.8681 14.0803L14.792 14.0842H14.084V14.7922C14.0837 15.206 13.7477 15.5419 13.334 15.5422C12.9199 15.5422 12.5842 15.2062 12.584 14.7922V14.0842H11.875C11.461 14.0842 11.1254 13.7481 11.125 13.3342C11.125 12.92 11.4608 12.5842 11.875 12.5842H12.584V11.8752C12.584 11.461 12.9197 11.1252 13.334 11.1252ZM4.11716 6.3977C3.5665 6.3977 3.15421 6.9074 3.27048 7.44848L4.49606 13.1086V13.1096C4.58153 13.5067 4.93323 13.7922 5.34274 13.7922H8.43845C8.42448 13.6414 8.41699 13.4887 8.41696 13.3342C8.41696 10.6192 10.6189 8.41723 13.334 8.41723C14.1962 8.41734 15.0066 8.63864 15.7109 9.02856L16.0537 7.44848C16.1707 6.90754 15.76 6.39792 15.207 6.3977H4.11716Z" fill="white"/></svg></span>Shop Now';
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = '<span class="vp-svg-span"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.1103 1.85961C12.4421 1.65781 12.8683 1.74384 13.0976 2.04711L13.1406 2.11059L14.8379 4.8977H15.207C16.7185 4.89792 17.8398 6.29312 17.5205 7.76684L17.0185 10.0813C17.7841 10.9483 18.25 12.0869 18.25 13.3342C18.2495 16.0486 16.0494 18.2499 13.334 18.2502L13.081 18.2444C11.1711 18.1477 9.54957 16.9595 8.82419 15.2922H5.34274C4.22914 15.2922 3.26392 14.516 3.02927 13.425V13.4241L1.80368 7.76684V7.76586C1.48566 6.29231 2.60815 4.8977 4.11716 4.8977H4.46774L6.01169 2.13402L6.0527 2.06957C6.27066 1.75813 6.69318 1.65659 7.0322 1.84594C7.39371 2.04799 7.52325 2.50488 7.32126 2.86645L6.18649 4.8977H13.082L11.8593 2.88988L11.8232 2.8225C11.6594 2.47956 11.7787 2.06158 12.1103 1.85961Z" fill="white"/></svg></span>Sold Out';
    }
  }

  // Update active state on labels
  wrapper.querySelectorAll('.vp-filterDropdownItem').forEach(function(label) {
    label.classList.remove('active');
  });
  input.closest('.vp-filterDropdownItem').classList.add('active');

  // Close dropdown
  wrapper.classList.remove('active');
});

// Add to Cart
document.querySelectorAll('.vp-add-to-cart').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    
    const variantId = this.dataset.variantId;
    if (!variantId || this.disabled) return;

    // Add loading state
    this.classList.add('loading');
    const originalText = this.innerHTML;
    this.innerHTML = '<span class="vp-svg-span">Adding...</span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      this.classList.remove('loading');
      this.innerHTML = '<span class="vp-svg-span">Added!</span>';
      
      // Reset button after 2 seconds
      setTimeout(() => {
        this.innerHTML = originalText;
      }, 2000);

      // Fetch updated sections and refresh cart drawer + icon bubble
      const sectionsToFetch = ['cart-drawer', 'cart-icon-bubble'];
      const sectionParams = sectionsToFetch.map(s => `sections[]=${s}`).join('&');
      
      fetch(`${window.Shopify.routes.root}cart.js?${sectionParams}`)
        .then(res => res.json())
        .then(cartData => {
          const cartDrawer = document.querySelector('cart-drawer');
          
          // Update header cart count badge
const cartNotification = document.querySelector('#cart-icon-bubble .vp-notification');
if (cartData.item_count > 0) {
  if (cartNotification) {
    // Update existing badge
    cartNotification.textContent = cartData.item_count;
  } else {
    // Create badge if it doesn't exist (cart was empty)
    const iconBubble = document.getElementById('cart-icon-bubble');
    if (iconBubble) {
      const notification = document.createElement('div');
      notification.className = 'vp-notification vp-text-overline vp-d-flex vp-j-c-center vp-a-i-center vp-f-d-column';
      notification.textContent = cartData.item_count;
      iconBubble.appendChild(notification);
    }
  }
}
          
          // Update cart drawer content
          if (cartData.sections && cartData.sections['cart-drawer']) {
            const html = new DOMParser().parseFromString(cartData.sections['cart-drawer'], 'text/html');
            
            // Update drawer inner content
            const newDrawerInner = html.querySelector('#CartDrawer');
            const currentDrawerInner = document.querySelector('#CartDrawer');
            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }
            
            // Re-attach overlay click listener
            const overlay = document.getElementById('CartDrawer-Overlay');
            if (overlay && cartDrawer) {
              overlay.addEventListener('click', () => cartDrawer.close());
            }
          }
          
          // Remove is-empty class since we just added something
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
          }
          
          // Update drawer count badge
          const drawerCount = document.querySelector('.gm-drawer-count');
          if (drawerCount && cartData.item_count) {
            drawerCount.textContent = cartData.item_count;
          }

          // Update Snap Finance monthly price
const snapMonthly = document.querySelector('.gm-snap-monthly');
if (snapMonthly && cartData.total_price) {
  const monthlyPrice = (cartData.total_price / 100 / 6).toFixed(2);
  snapMonthly.textContent = '$' + monthlyPrice + '/mo';
}
          
          // Open cart drawer first
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
          
          // Re-load recommendations after DOM update (with delay)
          setTimeout(() => {
            if (typeof loadDrawerRecommendations === 'function') {
              const slider = document.getElementById('drawer-rec-slider');
              if (slider) {
                slider.innerHTML = ''; // Clear so it reloads
              }
              loadDrawerRecommendations();
            }
          }, 150);
          
          // Publish cart update event for any other subscribers
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: cartData });
          }
        })
        .catch(err => {
          console.error('Error fetching cart sections:', err);
          // Fallback: just reload
          window.location.reload();
        });
    })
    .catch(error => {
      console.error('Error:', error);
      this.classList.remove('loading');
      this.innerHTML = originalText;
    });
  });
});
});




// ============================================
// HEADER - Predictive Search
// ============================================
(function() {
  var searchInput = document.querySelector('.vp-search-dropdown .vp-search-input');
  var searchIcon = document.querySelector('.vp-search-dropdown .vp-search-input-icon');
  var recentSection = document.querySelector('.vp-search-recent-section');
  var resultsSection = document.querySelector('.vp-search-results-section');
  var noResultsSection = document.querySelector('.vp-search-no-results-section');
  var resultsGrid = document.querySelector('.vp-search-results-grid');
  var loadingEl = document.querySelector('.vp-search-loading');
  var queryTextEl = document.querySelector('.vp-search-query-text');

  if (!searchInput || !resultsSection) return;

  var searchTimeout;

  // Perform search
  function performSearch(query) {
    if (!query || query.length < 2) {
      showRecentSection();
      return;
    }

    if (queryTextEl) queryTextEl.textContent = query;

    recentSection.style.display = 'none';
    noResultsSection.style.display = 'none';
    resultsSection.style.display = 'flex';
    loadingEl.style.display = 'flex';
    resultsGrid.style.display = 'none';

    saveRecentSearch(query);

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12')
      .then(function(response) { return response.json(); })
      .then(function(data) {
        loadingEl.style.display = 'none';
        
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        
        if (products.length === 0) {
          resultsSection.style.display = 'none';
          noResultsSection.style.display = 'flex';
        } else {
          noResultsSection.style.display = 'none';
          resultsGrid.style.display = 'grid';
          renderProducts(products);
        }
      })
      .catch(function(error) {
        console.error('Search error:', error);
        loadingEl.style.display = 'none';
        resultsSection.style.display = 'none';
        noResultsSection.style.display = 'flex';
      });
  }

 // Render search products - matching product card design
function renderProducts(products) {
  var container = document.getElementById('search-products-grid');
  if (!container) return;

  container.innerHTML = products.map(function(product) {
    var price = product.price;
    var comparePrice = product.compare_at_price_max || product.compare_at_price;
    var hasDiscount = comparePrice && comparePrice > price;
    var discountPercent = 0;
    
    if (hasDiscount) {
      discountPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
    }
    
    var shortTitle = truncateText(product.title, 40);
    var image = product.featured_image?.url || product.image || '';
    
    return '<div class="vp-product-card vp-search-result-card vp-d-flex vp-f-d-column vp-gap-16 vp-a-i-f-start">' +
      '<a href="' + product.url + '" class="vp-search-card-link">' +
        '<div class="vp-product-img">' +
          (image ? '<img src="' + image + '" alt="' + product.title + '" loading="lazy">' : '') +
          '<div class="vp-product-tags">' +
            (hasDiscount ? 
              '<div class="vp-product-label vp-product-label-discount vp-a-i-center vp-gap-4">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
                  '<path d="M8.00023 1.33301C8.26993 1.33305 8.53622 1.3934 8.77953 1.50977C8.99286 1.61177 9.1977 1.78646 9.6057 2.13379C9.71079 2.22808 9.82131 2.31675 9.93578 2.39941C10.1343 2.53269 10.3574 2.6248 10.592 2.6709C10.7314 2.69342 10.8719 2.70913 11.0129 2.7168C11.5469 2.75946 11.8147 2.78071 12.0373 2.85938C12.292 2.94914 12.5232 3.0952 12.7141 3.28613C12.905 3.47705 13.0511 3.70827 13.1409 3.96289C13.2194 4.18546 13.2408 4.45276 13.2834 4.98633C13.2911 5.12748 13.3058 5.26866 13.3284 5.4082C13.3745 5.64292 13.4675 5.86587 13.6008 6.06445C13.6835 6.17901 13.7721 6.28937 13.8664 6.39453C14.2137 6.8025 14.3885 7.00641 14.4905 7.21973C14.7258 7.71306 14.7258 8.28694 14.4905 8.78027C14.3885 8.9936 14.2138 9.19748 13.8664 9.60547C13.7279 9.76736 13.6588 9.84891 13.6008 9.93555C13.4682 10.1342 13.375 10.3572 13.3284 10.5918C13.3084 10.6938 13.3001 10.801 13.2834 11.0137C13.2408 11.5472 13.2194 11.8145 13.1409 12.0371C13.0511 12.2917 12.905 12.523 12.7141 12.7139C12.5232 12.9048 12.292 13.0509 12.0373 13.1406C11.8147 13.2193 11.5469 13.2405 11.0129 13.2832C10.8005 13.2999 10.694 13.3091 10.592 13.3291C10.3575 13.3757 10.1343 13.4674 9.93578 13.6006C9.84919 13.6585 9.7674 13.7278 9.6057 13.8662C9.1977 14.2135 8.99286 14.3882 8.77953 14.4902C8.28632 14.7253 7.71313 14.7255 7.21996 14.4902C7.00662 14.3882 6.80276 14.2135 6.39476 13.8662C6.23287 13.7276 6.15132 13.6586 6.06468 13.6006C5.86617 13.468 5.6429 13.3758 5.40843 13.3291C5.30643 13.3091 5.19923 13.2999 4.98656 13.2832C4.45295 13.2406 4.18569 13.2192 3.96312 13.1406C3.70845 13.0509 3.47633 12.9048 3.28539 12.7139C3.09463 12.523 2.94931 12.2916 2.85961 12.0371C2.78099 11.8145 2.75967 11.5473 2.71703 11.0137C2.70036 10.801 2.69113 10.6938 2.67113 10.5918C2.62447 10.3573 2.53283 10.1341 2.39964 9.93555C2.34164 9.84888 2.27171 9.76747 2.13304 9.60547C1.78586 9.19765 1.612 8.99352 1.51 8.78027C1.27466 8.28694 1.27466 7.71306 1.51 7.21973C1.61201 7.00649 1.78587 6.80235 2.13304 6.39453C2.27171 6.23253 2.34164 6.15112 2.39964 6.06445C2.53282 5.86592 2.62447 5.64267 2.67113 5.4082C2.69367 5.26866 2.70937 5.12748 2.71703 4.98633C2.75967 4.45266 2.78098 4.18549 2.85961 3.96289C2.94931 3.70838 3.09462 3.477 3.28539 3.28613C3.47633 3.09519 3.70845 2.94914 3.96312 2.85938C4.18569 2.78083 4.45295 2.75943 4.98656 2.7168C5.19923 2.70013 5.30643 2.6909 5.40843 2.6709C5.64291 2.6242 5.86617 2.53265 6.06468 2.39941C6.17925 2.31668 6.28959 2.22817 6.39476 2.13379C6.80276 1.78646 7.00662 1.61177 7.21996 1.50977C7.46344 1.39324 7.7303 1.33301 8.00023 1.33301ZM10.1702 5.28906C10.0264 5.28906 9.8881 5.34573 9.78636 5.44727L5.44652 9.78809C5.39249 9.83747 5.3489 9.89724 5.31859 9.96387C5.28826 10.0306 5.27141 10.1035 5.26976 10.1768C5.26816 10.2499 5.2816 10.3227 5.30882 10.3906C5.33611 10.4587 5.37712 10.5204 5.42894 10.5723C5.48077 10.6241 5.54255 10.6651 5.61058 10.6924C5.67849 10.7196 5.7513 10.733 5.82445 10.7314C5.89775 10.7298 5.97059 10.713 6.03734 10.6826C6.10399 10.6523 6.16372 10.6087 6.21312 10.5547L10.5539 6.21289C10.6553 6.11119 10.7121 5.97369 10.7121 5.83008C10.7121 5.72223 10.6802 5.61775 10.6213 5.5293L10.553 5.44727C10.4513 5.34591 10.3137 5.28911 10.1702 5.28906ZM9.80785 9.08594C9.61606 9.08597 9.43175 9.16223 9.29613 9.29785C9.16059 9.43349 9.08421 9.61781 9.08421 9.80957C9.08427 10.0013 9.16053 10.1857 9.29613 10.3213C9.43174 10.4569 9.61608 10.5322 9.80785 10.5322C9.99961 10.5322 10.1839 10.4568 10.3196 10.3213C10.4552 10.1857 10.5314 10.0013 10.5315 9.80957C10.5315 9.61775 10.4552 9.4335 10.3196 9.29785C10.1839 9.1622 9.99969 9.08594 9.80785 9.08594ZM6.19164 5.46973C5.9998 5.46973 5.81557 5.54599 5.67992 5.68164C5.54445 5.8172 5.46808 6.00073 5.468 6.19238C5.468 6.38422 5.54427 6.56845 5.67992 6.7041C5.81557 6.83975 5.9998 6.91602 6.19164 6.91602C6.38328 6.91593 6.56682 6.83957 6.70238 6.7041C6.83803 6.56845 6.91429 6.38422 6.91429 6.19238C6.91421 6.00066 6.83795 5.81722 6.70238 5.68164C6.5668 5.54607 6.38336 5.46981 6.19164 5.46973Z" fill="white"/>' +
                '</svg>' +
                '<span class="vp-text-s-semibold">' + discountPercent + '% Off</span>' +
              '</div>' 
            : '') +
          '</div>' +
        '</div>' +
      '</a>' +
      '<div class="vp-product-content vp-d-flex vp-f-d-column vp-gap-12 vp-w-100">' +
        '<div class="vp-product-info vp-d-flex vp-f-d-column vp-gap-8">' +
          '<div class="vp-product-texts">' +
            '<h3 class="vp-text-m-semibold">' +
              '<a href="' + product.url + '">' + shortTitle + '</a>' +
            '</h3>' +
          '</div>' +
        '</div>' +
        '<div class="vp-product-price vp-d-flex vp-j-c-space-between vp-a-i-center vp-gap-8">' +
          '<div class="vp-price vp-d-flex vp-gap-8 vp-a-i-center">' +
            '<span class="vp-h3 vp-current-price">' + formatMoney(price) + '</span>' +
            (hasDiscount ? '<span class="vp-text-xs-medium vp-compare-price"><del>' + formatMoney(comparePrice) + '</del></span>' : '') +
          '</div>' +
          '<a href="' + product.url + '" class="vp-btn-s-primary vp-gap-4">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">' +
              '<path d="M12.1103 1.85961C12.4421 1.65781 12.8683 1.74384 13.0976 2.04711L13.1406 2.11059L14.8379 4.8977H15.207C16.7185 4.89792 17.8398 6.29312 17.5205 7.76684L17.0185 10.0813C17.7841 10.9483 18.25 12.0869 18.25 13.3342C18.2495 16.0486 16.0494 18.2499 13.334 18.2502L13.081 18.2444C11.1711 18.1477 9.54957 16.9595 8.82419 15.2922H5.34274C4.22914 15.2922 3.26392 14.516 3.02927 13.425V13.4241L1.80368 7.76684V7.76586C1.48566 6.29231 2.60815 4.8977 4.11716 4.8977H4.46774L6.01169 2.13402L6.0527 2.06957C6.27066 1.75813 6.69318 1.65659 7.0322 1.84594C7.39371 2.04799 7.52325 2.50488 7.32126 2.86645L6.18649 4.8977H13.082L11.8593 2.88988L11.8232 2.8225C11.6594 2.47956 11.7787 2.06158 12.1103 1.85961ZM13.334 9.91723C11.4473 9.91723 9.91696 11.4476 9.91696 13.3342C9.91739 15.1616 11.3533 16.655 13.1582 16.7463L13.334 16.7502L13.5097 16.7463C15.3148 16.6546 16.7495 15.1614 16.75 13.3342C16.75 11.4477 15.221 9.91757 13.334 9.91723ZM13.334 11.1252C13.7479 11.1256 14.084 11.4612 14.084 11.8752V12.5842H14.792L14.8681 12.5881C15.2464 12.6265 15.542 12.9459 15.542 13.3342C15.5415 13.7223 15.2462 14.042 14.8681 14.0803L14.792 14.0842H14.084V14.7922C14.0837 15.206 13.7477 15.5419 13.334 15.5422C12.9199 15.5422 12.5842 15.2062 12.584 14.7922V14.0842H11.875C11.461 14.0842 11.1254 13.7481 11.125 13.3342C11.125 12.92 11.4608 12.5842 11.875 12.5842H12.584V11.8752C12.584 11.461 12.9197 11.1252 13.334 11.1252ZM4.11716 6.3977C3.5665 6.3977 3.15421 6.9074 3.27048 7.44848L4.49606 13.1086V13.1096C4.58153 13.5067 4.93323 13.7922 5.34274 13.7922H8.43845C8.42448 13.6414 8.41699 13.4887 8.41696 13.3342C8.41696 10.6192 10.6189 8.41723 13.334 8.41723C14.1962 8.41734 15.0066 8.63864 15.7109 9.02856L16.0537 7.44848C16.1707 6.90754 15.76 6.39792 15.207 6.3977H4.11716Z" fill="white"/>' +
            '</svg>' +
            '<span>Shop</span>' +
          '</a>' +
        '</div>' +
      '</div>' +
    '</div>';
  }).join('');
}
 

// Format money helper - Shopify API returns price in dollars as string
function formatMoney(price) {
  if (!price) return '$0.00';
  
  // If it's a string, parse it
  if (typeof price === 'string') {
    return '$' + parseFloat(price).toFixed(2);
  }
  
  // If number is large (over 100), it's likely in cents
  if (price > 100) {
    return '$' + (price / 100).toFixed(2);
  }
  
  // Otherwise it's already in dollars
  return '$' + parseFloat(price).toFixed(2);
}

  // Show recent section
  function showRecentSection() {
    recentSection.style.display = 'flex';
    resultsSection.style.display = 'none';
    noResultsSection.style.display = 'none';
  }

  // Save recent search
  function saveRecentSearch(query) {
    var searches = JSON.parse(localStorage.getItem('vp_recent_searches') || '[]');
    searches = searches.filter(function(s) { return s.toLowerCase() !== query.toLowerCase(); });
    searches.unshift(query);
    searches = searches.slice(0, 3);
    localStorage.setItem('vp_recent_searches', JSON.stringify(searches));
    renderRecentSearches();
  }

  // Render recent searches
  function renderRecentSearches() {
    var list = document.getElementById('recent-searches-list');
    if (!list) return;

    var searches = JSON.parse(localStorage.getItem('vp_recent_searches') || '[]');
    
    if (searches.length === 0) {
      list.innerHTML = '<p class="vp-text-xs-medium vp-no-recent-searches" style="color: var(--text-secondary);">No recent searches</p>';
      return;
    }

    list.innerHTML = searches.map(function(search) {
      return '<li class="vp-d-flex vp-gap-4 vp-a-i-center">' +
        '<a href="#" class="vp-recent-search-item vp-d-flex vp-gap-4 vp-a-i-center vp-text-xs-medium" data-query="' + search + '">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">' +
            '<path d="M8.45801 0C13.1295 0.000103489 16.916 3.78668 16.916 8.45801C16.9159 13.1293 13.1294 16.9159 8.45801 16.916C8.04408 16.9158 7.70815 16.58 7.70801 16.166C7.70811 15.752 8.04405 15.4162 8.45801 15.416C12.301 15.4159 15.4159 12.3008 15.416 8.45801C15.416 4.61518 12.3011 1.5001 8.45801 1.5C5.71784 1.50016 3.36825 3.08583 2.24023 5.39551H3.06152C3.47568 5.39551 3.81143 5.73137 3.81152 6.14551C3.81138 6.5596 3.47565 6.89551 3.06152 6.89551H1.13477C0.896258 6.89537 0.671501 6.78205 0.530273 6.58984C0.389069 6.39748 0.347577 6.14859 0.418945 5.9209C1.49518 2.49384 4.66568 0.000185092 8.45801 0ZM4.69238 15.5537C4.85328 15.2004 5.25421 15.0317 5.61426 15.1533L5.68555 15.1816L6.03027 15.3271C6.14616 15.3726 6.26364 15.415 6.38184 15.4541C6.77482 15.5845 6.98762 16.0093 6.85742 16.4023C6.72697 16.795 6.30305 17.0079 5.91016 16.8779C5.76634 16.8303 5.62342 16.7789 5.48242 16.7236L5.06445 16.5469L4.99609 16.5117C4.66793 16.3202 4.53187 15.907 4.69238 15.5537ZM3.48145 13.5791C3.69567 13.8096 3.92382 14.0248 4.16406 14.2236C4.48252 14.4879 4.52664 14.9605 4.2627 15.2793C3.99863 15.598 3.52602 15.6426 3.20703 15.3789C2.91622 15.1382 2.64113 14.8785 2.38281 14.6006L2.93262 14.0898L3.48145 13.5791ZM2.42188 13.54C2.72525 13.2584 3.19953 13.2759 3.48145 13.5791L2.38281 14.6006C2.10087 14.2972 2.11855 13.822 2.42188 13.54ZM1.9873 11.1572C2.0922 11.4339 2.21273 11.7049 2.34863 11.9678C2.53852 12.3356 2.39506 12.7883 2.02734 12.9785C1.68252 13.1568 1.26357 13.0407 1.05566 12.7227L1.0166 12.6572L0.898438 12.4199C0.783423 12.1809 0.678024 11.9365 0.583984 11.6885L1.28613 11.4229L1.9873 11.1572ZM1.01953 10.7217C1.40684 10.5749 1.84051 10.7699 1.9873 11.1572L0.583984 11.6885C0.437408 11.3014 0.632564 10.8686 1.01953 10.7217ZM8.45801 4.625C8.87211 4.62513 9.20801 4.96087 9.20801 5.375V8.14648L10.5303 9.46973L10.582 9.52637C10.822 9.82094 10.8047 10.2558 10.5303 10.5303C10.2558 10.8045 9.82085 10.822 9.52637 10.582L9.46973 10.5303L7.92773 8.98828C7.78741 8.84777 7.70813 8.65659 7.70801 8.45801V5.375C7.70801 4.96094 8.04401 4.62525 8.45801 4.625ZM0.75 7.70801C1.16402 7.70814 1.49987 8.04398 1.5 8.45801C1.50001 8.69503 1.51023 8.92986 1.53125 9.16113C1.56847 9.57339 1.26479 9.938 0.852539 9.97559C0.440192 10.0131 0.0758235 9.70914 0.0380859 9.29688C0.0128922 9.01974 1.38383e-05 8.73965 0 8.45801C0.000126374 8.0439 0.335864 7.70801 0.75 7.70801Z" fill="#4E3A2F"/>' +
          '</svg>' +
          search +
        '</a>' +
        '<div class="vp-recent-searches-close vp-d-flex" data-query="' + search + '">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
            '<path d="M2.45503 2.455C2.74798 2.16272 3.22301 2.16231 3.51569 2.455L5.99954 4.93885L8.4827 2.45569C8.77562 2.16308 9.25057 2.16289 9.54336 2.45569C9.83574 2.74853 9.83583 3.22358 9.54336 3.51635L7.0602 5.99951L9.54336 8.48267L9.59515 8.53999C9.83493 8.83434 9.81725 9.26883 9.54336 9.54333C9.26891 9.81779 8.8339 9.83571 8.53933 9.59581L8.4827 9.54333L5.99954 7.06017L3.51569 9.54402C3.22294 9.83677 2.74796 9.83649 2.45503 9.54402C2.16214 9.25113 2.16214 8.77626 2.45503 8.48336L4.93888 5.99951L2.45503 3.51566C2.16214 3.22277 2.16214 2.74789 2.45503 2.455Z" fill="#222222" fill-opacity="0.4"/>' +
          '</svg>' +
        '</div>' +
      '</li>';
    }).join('');

    list.querySelectorAll('.vp-recent-search-item').forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        var query = this.dataset.query;
        searchInput.value = query;
        performSearch(query);
      });
    });

    list.querySelectorAll('.vp-recent-searches-close').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var query = this.dataset.query;
        var searches = JSON.parse(localStorage.getItem('vp_recent_searches') || '[]');
        searches = searches.filter(function(s) { return s !== query; });
        localStorage.setItem('vp_recent_searches', JSON.stringify(searches));
        renderRecentSearches();
      });
    });
  }
 
 // Render recent viewed products
function renderRecentViewed() {
  var container = document.getElementById('recent-viewed-products');
  if (!container) return;

  var viewed = JSON.parse(localStorage.getItem('vp_recent_viewed') || '[]');
  
  if (viewed.length === 0) {
    container.innerHTML = '<p class="vp-text-xs-medium vp-no-recent-viewed" style="color: var(--text-secondary);">No recently viewed products</p>';
    return;
  }

  container.innerHTML = viewed.map(function(product) {
    var shortTitle = truncateText(product.title, 25); // 25 character limit
    
    return '<a href="' + product.url + '">' +
      '<div class="vp-mattress-card vp-d-flex vp-f-d-column vp-gap-12">' +
        '<div class="vp-mattress-img">' +
          '<img src="' + product.image + '" alt="' + product.title + '">' +
        '</div>' +
        '<div class="vp-mattress-info">' +
          '<h4 class="vp-text-xs-semibold">' + shortTitle + '</h4>' +
        '</div>' +
      '</div>' +
    '</a>';
  }).join('');
}

// Truncate text helper
function truncateText(text, limit) {
  if (text.length <= limit) return text;
  return text.substring(0, limit).trim() + '...';
}

  // Event listeners
  if (searchIcon) {
    searchIcon.addEventListener('click', function(e) {
      e.preventDefault();
      var query = searchInput.value.trim();
      if (query.length >= 2) {
        performSearch(query);
      }
    });
  }

  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var query = this.value.trim();
      if (query.length >= 2) {
        performSearch(query);
      }
    }
  });

  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    var query = this.value.trim();
    
    if (query.length < 2) {
      showRecentSection();
      return;
    }

    searchTimeout = setTimeout(function() {
      performSearch(query);
    }, 500);
  });

  searchInput.addEventListener('input', function() {
    if (this.value.trim() === '') {
      showRecentSection();
    }
  });

  // Initialize on page load
  renderRecentSearches();
  renderRecentViewed();
})();